import { SortingMapping } from '../models';
import { DataQuerySorting, SortingDirection } from '../DataQuery';
import { SortingRule } from 'react-table';

/**
 * Маппер для сортировки
 */
export class SortingMapper<TItem extends object, TSorting> {
  map(
    gridSorting: SortingRule<TItem>[],
    sortingMapping: SortingMapping<TItem, TSorting>,
  ): DataQuerySorting<TSorting> | undefined {
    if (gridSorting.length === 0) {
      return undefined;
    }
    const result: DataQuerySorting<TSorting> = [];
    gridSorting.forEach((rule) => {
      const propName = sortingMapping[rule.id as keyof TItem];
      if (propName) {
        result.push({
          propName,
          direction: rule.desc ? SortingDirection.Desc : SortingDirection.Asc,
        });
      } else {
        console.error('Не удалось найти сортировку, соответсвтующую колонке с именем ', rule.id);
      }
    });
    return result;
  }

  mapToGrid(
    querySorting: DataQuerySorting<TSorting>,
    sortingMapping: SortingMapping<TItem, TSorting>,
  ): SortingRule<TSorting>[] {
    return querySorting.map((item) => {
      const indexId = Object.values(sortingMapping).findIndex((s) => s === item.propName);
      return {
        id: Object.keys(sortingMapping)[indexId],
        desc: item.direction === SortingDirection.Desc,
      };
    });
  }
}
